import { Component, OnInit } from "@angular/core";
import { TokenService } from "../core/services/token.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class IndexComponent implements OnInit {
  nombreUsuario: string;

  constructor(private tokenService: TokenService, private router: Router) {}

  ngOnInit() {
    this.nombreUsuario = this.tokenService.getUserName();
    if (!this.tokenService.isLogged()) {
      this.router.navigate(["/login"]);
    }
  }
}
